// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"831":"0acf55c5","959":"877b34ae"}[chunkId] + ".chunk.css";
};